import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from '../../../shared/spinner.service'
import Swal from 'sweetalert2';
import { session } from '../../../../environments/environment.session'
import { EscalationService } from '../../service/escalation.service'
// export interface EscalationRule {
//   id: number;
//   category: string;
//   level: string;
//   officerRole: string;
//   time: number;
//   notificationModes: string[];
//   status: string;
// }

import { TranslationService } from '../../service/translation.service';

@Component({
  selector: 'app-escalation-matrix',
  templateUrl: './escalation-matrix.component.html',
  styleUrls: ['./escalation-matrix.component.css']
})
export class EscalationMatrixComponent implements OnInit {

  escalationRules: any[] = [];
  filteredRulesList: any[] = [];
  pagedRules: any[] = [];

  searchText: string = '';

  currentPage = 1;
  pageSize = 10;
  totalPages = 0;
  page_list = [5, 10, 20, 50, 100];
  totalRecords = 0;

  escalationLevels: string[] = [
    'Level 1 - Junior Engineer/Field Officer',
    'Level 2 - Assistant Engineer',
    'Level 3 - Executive Engineer'
  ];

  levelOfficerRoleMap: { [key: string]: string } = {
    'Level 1 - Junior Engineer/Field Officer': 'Junior Engineer/Field Officer',
    'Level 2 - Assistant Engineer': 'Assistant Engineer',
    'Level 3 - Executive Engineer': 'Executive Engineer'
  };

  notificationModesList: string[] = ['SMS', 'Email', 'Dashboard'];

  complaintCategories = [
    { id: 1, name: 'Cleanliness' },
    { id: 2, name: 'Street Light' },
    { id: 3, name: 'Water Supply' },
    { id: 4, name: 'Road Repair' },
    { id: 5, name: 'Drainage' }
  ];

  newEscalationRule: any = {};

  constructor(private es: EscalationService, private modalService: NgbModal, private tspinner: SpinnerService, public translation: TranslationService) { }
  erpUser: any
  ngOnInit() {
    this.erpUser = JSON.parse(atob(session.erpUser))
    this.getEscalationRules();
  }

  open(modalRef: any): void {
    this.newEscalationRule = {
      category: '',
      level: '',
      escalationTime: null,
      notificationModes: [],
      isActive: true
    };
    this.modalService.open(modalRef, { windowClass: 'modal-md-custom', size: 'lg', backdrop: 'static', centered: true });
  }


  allEscalationRule: any = []
  async getEscalationRules() {
    let obj = { b_acct_id: this.erpUser.b_acct_id }
    this.tspinner.show('','')
    let resp = await this.es.getEscalationRules(JSON.stringify(obj))
    if (resp['error'] == false) {
      this.allEscalationRule = resp['data']
      this.applyFilters();
      this.tspinner.hide();
    } else {
      this.tspinner.hide()
      Swal.fire(this.translation.t('common', 'oopsTitle'), resp['data'], 'error')
    }

    
  }

  applyFilters(): void {
    this.filteredRulesList = this.allEscalationRule.filter((rule:any) =>
      (rule.time.toString()).toLowerCase().includes(this.searchText.toLowerCase())
    );
    this.totalRecords = this.filteredRulesList.length;
    this.updatePages();
    this.updatePagedData();
  }

  updatePages(): void {
    this.totalPages = Math.ceil(this.totalRecords / this.pageSize) || 1;
  }

  updatePagedData(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.pagedRules = this.filteredRulesList.slice(start, end);
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagedData();
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagedData();
    }
  }

  changePageSize(): void {
    this.currentPage = 1;
    this.updatePages();
    this.updatePagedData();
  }

  onSearchChange(): void {
    this.currentPage = 1;
    this.applyFilters();
  }

 async addEscalationRule() {
  // const level = this.newEscalationRule.level?.trim();
  // const category = this.newEscalationRule.category?.trim();
  const time = this.newEscalationRule.time;
  const obj = {
    ...this.newEscalationRule,
    // level: level,
    // category: category,
    b_acct_id: this.erpUser.b_acct_id,
    create_user_id: this.erpUser.le_id
  };

  this.tspinner.show('', '');

  try {
    const resp = await this.es.addEscalationRules(obj);

    if (resp['error'] === false) {
      await this.getEscalationRules();
      this.modalService.dismissAll();
      this.applyFilters();
      Swal.fire(this.translation.t('common', 'successTitle'), resp['data'], 'success');
    } else {
      Swal.fire(this.translation.t('common', 'oopsTitle'), resp['data'], 'error');
    }
  } catch (error) {
    Swal.fire(this.translation.t('common', 'errorTitle'), this.translation.t('common', 'somethingWentWrong'), 'error');
  } finally {
    this.tspinner.hide();
  }
}


  onNotificationModeChange(mode: string, isChecked: boolean): void {
    const modes = this.newEscalationRule.notificationModes;
    if (isChecked) {
      if (!modes.includes(mode)) {
        modes.push(mode);
      }
    } else {
      const index = modes.indexOf(mode);
      if (index > -1) {
        modes.splice(index, 1);
      }
    }
  }

  getCheckedValue(event: Event): boolean {
    return (event.target as HTMLInputElement).checked;
  }

  onEdit(modalRef:any,element: any): void {
        this.newEscalationRule = {
      category: '',
      level: '',
      id:element.id,
      time:element.time,
      es_id:element.es_id,
      escalationTime: null,
      notificationModes: [],
      isActive: true
    };
    this.modalService.open(modalRef, { windowClass: 'modal-md-custom', size: 'lg', backdrop: 'static', centered: true });
  }

  onDelete(rule: any): void {
    // this.escalationRules = this.escalationRules.filter(r => r.id !== rule.id);
    // this.applyFilters();
  }

  async updateEscalationRule() {
    
      const result = await Swal.fire({
        title: this.translation.t('common', 'areYouSure'),
        text: this.translation.t('adminEscalationMatrix', 'updateConfirmText'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.translation.t('common', 'update'),
        cancelButtonText: this.translation.t('common', 'cancel'),
        showLoaderOnConfirm: true,
      });

      if (!result.isConfirmed) {
         return
      }

    let obj: any = { ...this.newEscalationRule }
 

    if (!this.newEscalationRule.time) {
      Swal.fire(this.translation.t('common', 'oopsTitle'), this.translation.t('common', 'pleaseFillAllFields'), 'info');
      return;
    }

    obj['b_acct_id'] = this.erpUser.b_acct_id
    obj['create_user_id'] = this.erpUser.le_id
    obj['update_user_id'] = this.erpUser.le_id
    obj['update_status'] = 'UPDATED'
  
    let resp = await this.es.updateEscalationRules(obj);
    if (resp['error'] == false) {
      await this.getEscalationRules();
      this.modalService.dismissAll();
      this.applyFilters();

      Swal.fire(this.translation.t('common', 'successTitle'), resp['data'], 'success');
    } else {

      Swal.fire(this.translation.t('common', 'oopsTitle'), resp['data'], 'info');
    }

    // const deptName = this.newDepartment.department_name?.trim();
    // const deptCode = this.newDepartment.dep_cd?.trim();

    // if (!deptName || !deptCode) {
    //   Swal.fire('Oops !!', 'Please fill all required fields.', 'info');
    //   return;
    // }

    // const index = this.allDepartment.findIndex(
    //   (dept: any) => dept.dep_cd === this.selectedDepartment.dep_cd
    // );

    // if (index !== -1) {
    //   this.allDepartment[index] = {
    //     ...this.allDepartment[index],
    //     department_name: deptName,
    //     dep_cd: deptCode,
    //     status: this.newDepartment.status
    //   };
    // }

    // this.modalService.dismissAll();
    // this.applyFilters();

    // Swal.fire('Success', 'Department updated successfully.', 'success');
  }


  async deleteEscalationRule(element :any) {

    console.log(this.allEscalationRule.length==1)
    if(this.allEscalationRule.length==1){
      Swal.fire(this.translation.t('common', 'oopsTitle'), this.translation.t('adminEscalationMatrix', 'atLeastOneRule'),'info')
      return
    }

    const result = await Swal.fire({
        title: this.translation.t('common', 'areYouSure'),
        text: this.translation.t('adminEscalationMatrix', 'deleteConfirmText'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.translation.t('common', 'delete'),
        cancelButtonText: this.translation.t('common', 'cancel'),
        showLoaderOnConfirm: true,
    });

    if (!result.isConfirmed) {
         return
      }

    let obj: any = {}
    obj['b_acct_id'] = this.erpUser.b_acct_id
    obj['create_user_id'] = this.erpUser.le_id
    obj['update_user_id'] = this.erpUser.le_id
    obj['es_id'] = element.es_id
    obj['id'] = element.id
    obj['status'] = 'DELETED'
    this.tspinner.show('','')
    let resp = await this.es.deleteEscalationRules(JSON.stringify(obj));
    if (resp['error'] == false) {
      await this.getEscalationRules();
      this.applyFilters();
      this.tspinner.hide()
      Swal.fire(this.translation.t('common', 'successTitle'), resp['data'], 'success');
    } else {
      this.tspinner.hide()
      Swal.fire(this.translation.t('common', 'oopsTitle'), resp['data'], 'info');
    }
 
  }


}
